import {createAction, handleActions} from 'redux-actions';
import {Record} from 'immutable';

const INITIALIZE_NEST = '@@nest/INITIALIZE_NEST';
const SET_AWAIR_QUERY_PARAMS = '@@nest/SET_AWAIR_QUERY_PARAMS';
const SET_TARGET_ID = '@@nest/SET_TARGET_ID';
const SET_INITIAL_TRIGGER_ENTITIES = '@@nest/SET_INITIAL_TRIGGER_ENTITIES';
const SET_CHANGED_TRIGGER_ENTITIES = '@@nest/SET_CHANGED_TRIGGER_ENTITIES';
const SET_LOADING = '@@nest/SET_LOADING';
const UNSET_LOADING = '@@nest/UNSET_LOADING';
const CONVERT_TO_INITIAL_VALUE = '@@nest/CONVERT_TO_INITIAL_VALUE';
const HIDE_COMPLETE_MODAL = '@@nest/HIDE_COMPLETE_MODAL';

export const actionCreators = {
  initializeNest: createAction(INITIALIZE_NEST),
  setAwairQueryParams: createAction(SET_AWAIR_QUERY_PARAMS),
  setTargetId: createAction(SET_TARGET_ID),
  setInitialTriggerEntities: createAction(SET_INITIAL_TRIGGER_ENTITIES),
  setChangedTriggerEntities: createAction(SET_CHANGED_TRIGGER_ENTITIES),
  setLoading: createAction(SET_LOADING),
  unsetLoading: createAction(UNSET_LOADING),
  convertToInitialValue: createAction(CONVERT_TO_INITIAL_VALUE),
  hideCompleteModal: createAction(HIDE_COMPLETE_MODAL)
};

const AwairQueryParamsSubRecord = Record({
  deviceUuid: '',
  deviceType: '',
  accessToken: ''
});

const IsCompleteModalClosedSubRecord = Record({
  isClosed: true,
  text: 'Saved!'
})

const NestRecord = Record({
  awairQueryParams: AwairQueryParamsSubRecord(),
  targetId: '',
  initialTriggerEntities: {},
  changedTriggerEntities: {},
  isLoading: false,
  isValueInitialized: false,
  isCompleteModalClosed: IsCompleteModalClosedSubRecord(),
});

const initialState = NestRecord();

export default handleActions({
  [INITIALIZE_NEST]: () => initialState,
  [SET_AWAIR_QUERY_PARAMS]: (state, {payload: awairQueryParams}) => state.set('awairQueryParams', awairQueryParams),
  [SET_TARGET_ID]: (state, {payload: targetId}) => state.set('targetId', targetId),
  [SET_INITIAL_TRIGGER_ENTITIES]: (state, {payload: initialTriggerEntities}) => state.set('initialTriggerEntities', initialTriggerEntities),
  [SET_CHANGED_TRIGGER_ENTITIES]: (state, {payload: changedTriggerEntities}) => state.set('changedTriggerEntities', changedTriggerEntities),
  [SET_LOADING]: (state) => state.set('isLoading', true),
  [UNSET_LOADING]: (state) => state.set('isLoading', false),
  [CONVERT_TO_INITIAL_VALUE]: (state, {payload: isValueInitialized}) => state.set('isValueInitialized', isValueInitialized),
  [HIDE_COMPLETE_MODAL]: (state, {payload: isCompleteModalClosed}) => state.set('isCompleteModalClosed', isCompleteModalClosed),
}, initialState);


// WEBPACK FOOTER //
// ./src/store/modules/nest.js